import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Flex from 'components/common/Flex';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import RegistrationForm from './components/RegistrationForm';
import bgImg from 'assets/img/generic/15.jpg';

const Register = () => {
  const { t } = useTranslation();

  return (
    <AuthSplitLayout bgProps={{ image: bgImg }}>
      <Flex alignItems="center" justifyContent="between">
        <h3>{t('LOGIN.REGISTER')}</h3>
        <p className="mb-0 fs--1">
          <span className="fw-semi-bold">{t('LOGIN.ASK_HAVE_ACCOUNT')} </span>
          <Link to="/login">{t('LOGIN.LOGIN')}</Link>
        </p>
      </Flex>
      <RegistrationForm hasLabel />
      <p className="mt-3 mb-0 fs--1 text-600">
        <span className="fw-semi-bold">{t('WAITLIST.WANT_TO_JOIN')} </span>
        <Link to="/waitlist">{t('LOGIN.GET_STARTED')}</Link>
      </p>
    </AuthSplitLayout>
  );
};

export default Register;
